/* eslint-disable camelcase */
import Request from "shared/Request";

export const loadPages = () => {
  return dispatch => {
    return Request.get("/pages").then(({ data }) => {
      dispatch(setPages(data.pages));
    });
  };
};

const setPages = pages => ({
  type: "SET_PAGES",
  payload: pages
});

/**
 * Responsável por informar quando uma requisição começa e termina
 * @param {String} inRequest Informa qual requisição está sendo processada.
 */
export const setRequestPending = inRequest => ({
  type: "HEADER_SET_REQUEST_PENDING",
  payload: inRequest
});

/**
 * Responsável por fazer uma requisição enviando um objeto com informações
 * de uma página para serem atualizadas e disparar metodos
 * para atualizar a página ativa com as informações novas e fechar o dropdown.
 * @param {Integer} id id da página ser atualizada
 * @param {Object} page objeto para ser atualizado
 */
export const requestUpdate = (id, page) => {
  return dispatch => {
    dispatch(setRequestPending("status"));
    dispatch(handleStatusDropdown(false));

    return Request.put(`/pages/${id}`, { page })
      .then(({ data }) => {
        const { iframe_token, ...page } = data;
        dispatch({ type: "SET_PAGE", payload: page });
        dispatch(setRequestPending(null));
      })
      .catch(error => {
        dispatch(setRequestPending(null));
        return error;
      });
  };
};

/**
 * Responsável por fazer uma requisição enviando um objeto com informações
 * para criar uma página (necessário somente o name) e disparar metodos
 * para setar a nova página como ativa e atualizar o array com todas as páginas
 * @param {Object} page objeto para criar uma página
 */
export const requestCreate = page => {
  return dispatch => {
    dispatch(setRequestPending("create"));
    return Request.post("/pages", { page })
      .then(resp => {
        dispatch(setRequestPending(null));
        dispatch(addPage(resp.data));
        dispatch(handleModal(false));
      })
      .catch(error => {
        dispatch(setRequestPending(null));
      });
  };
};

/**
 * Responsável por inserir item no array de páginas
 * @param {Object} page objeto que vai ser inserido
 */
export const addPage = page => {
  return (dispatch, getState) => {
    const { header } = getState();
    const pages = [page, ...header.pages];
    dispatch(setPages(pages));
  };
};

/**
 * Responsável identificar e alterar um item no array de páginas
 * @param {Object} pg objeto que vai ser atualizado
 */
export const updatePages = pg => {
  return (dispatch, getState) => {
    const { header } = getState();
    const pages = header.pages.map(page => {
      if (page.id === pg.id) return pg;
      return page;
    });
    dispatch(setPages(pages));
  };
};

/**
 * Responsável por abrir/fechar o dropdown
 * @param {Bool} status
 */
export const handleStatusDropdown = status => ({
  type: "HEADER_STATUS_DROPDOWN",
  payload: status
});

/**
 * Responsável por abrir/fechar o modal
 * @param {Bool} status
 */
export const handleModal = status => ({
  type: "HEADER_MODAL",
  payload: status
});
